import { useEffect, useCallback, useState } from 'react';
import { breakpoints, Breakpoint } from 'theme/breakpoints';
import { debounce } from 'lodash-es';

interface IViewport {
  width: number;
  orientation: 'landscape' | 'portrait';
  ratio: number;
  device: Breakpoint;
}

export const useViewport = () => {
  const [viewport, setViewPort] = useState<IViewport>({
    width: Number.MAX_SAFE_INTEGER,
    orientation: 'landscape',
    ratio: 2,
    device: 'sm',
  });
  
  const handleSetViewport = debounce(useCallback(() => {
    const { innerWidth, innerHeight } = window;
    const calculateDevice = Object.keys(breakpoints).reduce((acc, cur) => {
      return innerWidth > breakpoints[cur as Breakpoint] ? cur : acc;
    }, 'sm');
    
    setViewPort({
      width: innerWidth,
      orientation: innerWidth / innerHeight > 1.33 ? 'landscape' : 'portrait',
      ratio: Number((innerWidth / innerHeight).toFixed(2)),
      device: calculateDevice as Breakpoint,
    });
  }, []), 100);

  useEffect(() => {
    handleSetViewport();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    window.addEventListener('resize', handleSetViewport);
    return () => {
      window.removeEventListener('resize', handleSetViewport);
    };
  }, [handleSetViewport]);

  return { ...viewport };
};
